import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { ReportsData, ReportsPayload } from "./@types";

const getReports = async (params: ReportsPayload) => {
  const { data } = await apiInputService.get("/report/byType", {
    params: params,
  });

  return data as ReportsData;
};

export const useReports = (options?: any) => {
  return useMutation(getReports, {
    retry: 3,
    ...options,
  });
};
